import React from 'react'

export default function NotFound() {
  return (
<>
<h1>Page Not Found Please Go Back To Home Page</h1>
</>  )
}
